import { Tooltip, TooltipProps, TooltipPosition,TooltipVariant } from ".";
import React from "react";
import { ComponentInterfaceBaseClass } from "@att-bit/duc.utils-ts.types";
import { IconSvg, IconSvgSizes } from "@att-bit/duc.components.icon-svg";

export class TooltipInterface
  extends ComponentInterfaceBaseClass
  implements TooltipProps
{
    boxWidth: number;
    children: any;
    offset: number;
    position: TooltipPosition;
    variant: TooltipVariant;
    className: string;
    helpText: string;
    zIndex: boolean;
    id: string;
    styleOfChildContainer: object;
    analyticsData: string;
    tooltipAnalytics: boolean;

  static initWithSanity(key, feed) {
    const tconfigs = feed.configs;
    const t = new TooltipInterface();
    const tooltipTxt = feed.tooltipText.text ? feed.tooltipText.text : feed.tooltipText;
    //const iconSvg = IconSvgInterface.initWithSanity('iconSvg', feed.icon ? feed.icon : {});
    const tcontent = React.createElement(Tooltip.Content, {key: 1}, 
      React.createElement("div", {dangerouslySetInnerHTML: { __html: tooltipTxt }}));
    const trigElement = React.createElement("div", {key: 2, className: "rel", style: { height: 18, top: -1, width: 18 }}, 
      React.createElement(IconSvg,
        {
          svgNodeStr: feed.icon,
          color: feed.iconColor ? feed.iconColor : ((tconfigs && tconfigs.variant && tconfigs.variant !== "") ? "color-white" : "color-gray-700")
        }
      )
    );
    if (tconfigs) {
        t.boxWidth = tconfigs.boxWidth;
        t.offset = tconfigs.offset;
        t.position = tconfigs.position;
        t.variant = tconfigs.variant;
        t.className = tconfigs.className;
        t.zIndex = tconfigs.zIndex;
        t.styleOfChildContainer = tconfigs.styleOfChildContainer;
    }
    t.id = feed.id;
    t.analyticsData = feed.analyticsData;
    t.tooltipAnalytics = feed.tooltipAnalytics;
    t.children = [tcontent, trigElement];
    return t;
  }
  toProps(): TooltipProps {
    const props = {
        boxWidth: this.boxWidth,
        children: this.children,
        offset: this.offset,
        position: this.position,
        variant: this.variant,
        className: this.className,
        helpText: this.helpText,
        zIndex: this.zIndex,
        id: this.id,
        styleOfChildContainer: this.styleOfChildContainer,
        analyticsData: this.analyticsData,
        tooltipAnalytics: this.tooltipAnalytics,
    };
    return props;
  }
  toJsx(): JSX.Element {
    return React.createElement(Tooltip, {
      ...this.toProps(),
    });
  }
}
